import React, { useEffect } from "react";

import Loader from "components/Loading/Loader";
import { Card } from "@mui/material";
// store
import { useSelector } from "react-redux";
import { menudataSelector } from "reducers/menudata/menudata";
import { scheduledataSelector } from "reducers/scheduledata/scheduledata";
import { orderdataSelector } from "reducers/orderdata/orderdata";
import GroupOrdersDay from "./GroupOrdersDay";
import ScheduleDay from "../Schedule/ScheduleDay";

function GroupOrdersWeek() {
  const menudata = useSelector(menudataSelector);
  const scheduledata = useSelector(scheduledataSelector);
  const orderdata = useSelector(orderdataSelector);

  if (!menudata || !menudata.data || !menudata.data.lunchMenuItems) {
    console.log("no data");
    return (
      <Card>
        <div className="loader-container mt-4">
          {" "}
          Loading menudata ...<br></br>
          <br></br> <Loader w="25" />{" "}
        </div>
      </Card>
    );
  }

  if (scheduledata && scheduledata.errorMessage) {
    return (
      <Card>
        <div className="loader-container mb-4">
          {" "}
          Failure getting schedule: {scheduledata.errorMessage} <br></br>
          <br></br>
        </div>
      </Card>
    );
  }

  // check if there is scheduledata loaded, if not abort
  // check if there is scheduledata loaded, if not abort
  // check if there is scheduledata loaded, if not abort
  if (
    !scheduledata ||
    !scheduledata.selectedWeekNumber ||
    !scheduledata.dates
  ) {
    return (
      <Card>
        <div className="loader-container mt-4">
          {" "}
          Loading scheduledata ...<br></br>
          <br></br> <Loader w="25" />{" "}
        </div>
      </Card>
    );
  }

  // if the weekMenusClient does not have values for the selected week yet, return loading
  // if the weekMenusClient does not have values for the selected week yet, return loading
  // if the weekMenusClient does not have values for the selected week yet, return loading
  if (!scheduledata.menus.hasOwnProperty(scheduledata.selectedWeekNumber)) {
    return (
      <Card>
        <div className="loader-container mt-4">
          {" "}
          Loading scheduledata ...<br></br>
          <br></br> <Loader w="25" />{" "}
        </div>
      </Card>
    );
  }

  if (
    !orderdata ||
    !orderdata.ordersForGroups.hasOwnProperty(scheduledata.selectedWeekNumber)
  ) {
    console.log("no orderdata", orderdata);
    return (
      <Card>
        <div className="loader-container">
          {" "}
          Loading Orders ...<br></br>
          <br></br> <Loader w="25" />{" "}
        </div>
      </Card>
    );
  }

  // for conveniance map an array of lunchmenuitems and use the menu_numb as key
  // for conveniance map an array of lunchmenuitems and use the menu_numb as key
  // for conveniance map an array of lunchmenuitems and use the menu_numb as key
  let mappedMenus = [];
  Object.keys(menudata.data.lunchMenuItems).map(key => {
    mappedMenus[menudata.data.lunchMenuItems[key]["MENU_NUMB"]] =
      menudata.data.lunchMenuItems[key];
  });

  let mappedAllergies = [];
  Object.keys(menudata.data.allergies).map(key => {
    mappedAllergies[menudata.data.allergies[key]["ALGEN_CODE"]] =
      menudata.data.allergies[key];
  });

  const weekdays = [];
  let selectedWeekDates = [];
  if (scheduledata.selectedDay) {
    console.log("selectedweekdates day", scheduledata.selectedDay);
    selectedWeekDates = [scheduledata.dates[scheduledata.selectedWeekNumber][scheduledata.selectedDay]]
  } else {
    selectedWeekDates = scheduledata.dates[scheduledata.selectedWeekNumber];
  }

  console.log("selectedweekdates", selectedWeekDates);

  // loop through the SAP dates for the current week
  // and create weekdays for the days
  Object.values(selectedWeekDates).forEach(date => {
    let menusForDay = scheduledata.menus[scheduledata.selectedWeekNumber][date];
    let ordersForDay =
      orderdata.ordersForGroups[scheduledata.selectedWeekNumber][date];

    console.log("groupOrdersweek -", ordersForDay);

    weekdays.push(
      <GroupOrdersDay
        id={scheduledata.selectedDay !== false ? scheduledata.selectedDay : weekdays.length }
        menus={menusForDay}
        mappedMenus={mappedMenus}
        orders={ordersForDay}
        date={date}
        allergies={mappedAllergies}
        weeknumber={scheduledata.selectedWeekNumber}
      ></GroupOrdersDay>
    );
  });

  return Object.keys(weekdays).map(key => {
    return (
      <div className="mt-2" key={"weekday" + key}>
        {weekdays[key]}
      </div>
    );
  });
}

export default GroupOrdersWeek;
